var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacKfw85(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "167px",
    height: "247px",
    viewBox: "-0.5 -0.5 167 247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3 243 L 3 125",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 243 M 3 243 C 1.76 211.27 4.82 181.84 3 125 M 3 243 C 3.15 200.26 4.21 159.7 3 125",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 103 L 83 3",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 103 M 3 103 C 25.6 75.56 44.65 51.1 83 3 M 3 103 C 22.25 79.38 38.96 57.21 83 3",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 243 L 163 243",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 243 M 3 243 C 45.71 243.63 88.75 241.83 163 243 M 3 243 C 50.88 240.97 98.78 240.63 163 243",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 243 L 163 123",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 243 M 163 243 C 161.72 211.63 161.25 178.27 163 123 M 163 243 C 162.26 198.27 162.04 154.74 163 123",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 103 L 83 3",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 103 M 163 103 C 139.33 76.6 120.5 52.73 83 3 M 163 103 C 143.98 78.8 123.96 54.69 83 3",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 108,
    width: 147,
    height: 128,
    fill: "#004c3f",
    stroke: "#004c3f",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36 -12 L 129 61.5 L 36 135 Z",
    fill: "#004c3f",
    stroke: "none",
    transform: "rotate(-90,82.5,61.5)",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 57 -3.87 L 109 37.63 L 57 79.13 Z",
    fill: "#ffffff",
    stroke: "none",
    transform: "rotate(-90,83,37.63)",
    pointerEvents: "all"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacKfw85);
export default __webpack_public_path__ + "static/media/fac_kfw85.2c85212e7fa97a4464fdd60e05b05690.svg";
export { ForwardRef as ReactComponent };